export default __webpack_public_path__ + "static/media/video.81eeff39.svg";